import InfoUp from '@/icons/info-up.svg';
import { cn } from '@/utils';

const VARIANTS = {
	ERROR: 'error',
	INFO: 'info',
	SUCCESS: 'success',
	WARNING: 'warning'
};

function Alert({ className, classNameIcon, message, variant = 'info' }) {
	return (
		<div
			className={cn(
				'flex items-start gap-1 rounded-lg bg-orange px-2 py-1 text-[0.625rem] leading-4 text-white',
				className
			)}
			role="alert"
		>
			{variant === VARIANTS.INFO && (
				<InfoUp aria-hidden className={cn('size-4', classNameIcon)} />
			)}
			<div className="flex-1 font-bold">{message}</div>
		</div>
	);
}

export default Alert;
